export default function PrivacyNotice() {
  return (
    <div style={page}>
      <div style={card}>
        <a href="/" style={backLink}>
          ← Back to homepage
        </a>

        <h1 style={title}>Privacy Notice</h1>
        <p style={updated}>
          EmPi — em-pi.ai
          <br />
          Last updated: July 2026
        </p>

        <Section title="Who is responsible">
          <p>EmPi is operated by Katerina Triantafyllou, based in Austria.</p>
          <p>
            Email:{" "}
            <a href="mailto:privacy@em-pi.ai" style={link}>
              privacy@em-pi.ai
            </a>
          </p>
        </Section>

        <Section title="Using the EmPi chat">
          <p>
            When you send a message to EmPi, your message is processed to
            generate a response.
          </p>
          <p>
            If you choose to include information about your body, such as your
            cycle phase, perimenopause or menopause, this may include
            health-related personal data.
          </p>
          <p>Sharing this information is always optional.</p>
        </Section>

        <Section title="How your message is processed">
          <p>
            To generate EmPi&apos;s responses, your messages are sent through
            EmPi&apos;s serverless function to OpenAI&apos;s API.
          </p>
          <p>
            OpenAI may process and temporarily retain API inputs and outputs
            according to its API data policies. EmPi&apos;s API data is not used
            to train OpenAI&apos;s models by default.
          </p>
        </Section>

        <Section title="International processing">
          <p>OpenAI processes API requests in the United States.</p>
          <p>
            OpenAI participates in the EU-US Data Privacy Framework and provides
            a Data Processing Addendum for business customers.
          </p>
        </Section>

        <Section title="What EmPi stores">
          <p>
            EmPi is designed not to retain conversation history between
            sessions.
          </p>
          <p>Each new session starts without previous conversation history.</p>
        </Section>

        <Section title="Waitlist">
          <p>
            If you choose to join the EmPi waitlist, we collect your email
            address.
          </p>
          <p>
            Your email is processed and stored through Netlify and is used only
            to send occasional updates about EmPi.
          </p>
          <p>You can unsubscribe at any time.</p>
        </Section>

        <Section title="Your rights">
          <p>
            If you are located in the European Economic Area, you have rights
            under the GDPR, including the right to request access to your
            personal data, request correction or deletion where applicable,
            withdraw consent where consent is the legal basis, and lodge a
            complaint with your local supervisory authority.
          </p>
          <p>
            Because EmPi does not retain conversation history between sessions,
            there is generally no stored chat history for us to provide or
            delete.
          </p>
        </Section>

        <Section title="Changes">
          <p>
            If EmPi&apos;s data processing changes, this Privacy Notice will be
            updated before those changes take effect.
          </p>
          <p>
            The date at the top of this page will always show the latest
            version.
          </p>
        </Section>

        <Section title="Learn more">
          <ul style={list}>
            <li>
              <a
                style={link}
                href="https://developers.openai.com/api/docs/guides/your-data"
                target="_blank"
                rel="noreferrer">
                OpenAI API data handling
              </a>
            </li>
            <li>
              <a
                style={link}
                href="https://commission.europa.eu/law/law-topic/data-protection_en"
                target="_blank"
                rel="noreferrer">
                European Commission — Data protection
              </a>
            </li>
          </ul>
        </Section>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section style={section}>
      <h2 style={sectionTitle}>{title}</h2>
      <div style={body}>{children}</div>
    </section>
  );
}

const colors = {
  background: "#F5F5F7",
  card: "#FFFFFF",
  text: "#1D1D1F",
  secondaryText: "#6E6E73",
  border: "#E5E5E7",
};

const page = {
  minHeight: "100vh",
  background: colors.background,
  padding: "40px 20px",
  color: colors.text,
};

const card = {
  maxWidth: 760,
  margin: "0 auto",
  background: colors.card,
  border: `1px solid ${colors.border}`,
  borderRadius: 24,
  padding: 28,
  boxShadow: "0 8px 24px rgba(0,0,0,0.04)",
};

const backLink = {
  display: "inline-block",
  marginBottom: 18,
  fontSize: 14,
  color: colors.secondaryText,
  textDecoration: "none",
};

const title = {
  margin: "0 0 8px",
  fontSize: 36,
  lineHeight: 1.1,
};

const updated = {
  margin: "0 0 28px",
  fontSize: 15,
  lineHeight: 1.6,
  color: colors.secondaryText,
};

const section = {
  borderTop: `1px solid ${colors.border}`,
  paddingTop: 22,
  marginTop: 22,
};

const sectionTitle = {
  margin: "0 0 10px",
  fontSize: 20,
};

const body = {
  fontSize: 15,
  lineHeight: 1.7,
  color: colors.text,
};

const list = {
  paddingLeft: 20,
};

const link = {
  color: colors.text,
  fontWeight: 600,
};
